import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'gold' | 'track' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'gold',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  return <div className={`${alignment} ${className}`} data-id="element-197" data-mp="gjgj8u6d7cmj">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-198" data-mp="giwyz6t8sc5c">{eyebrow}</Pill> : null}
      <h2 className={`font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem] lg:text-[3rem] ${eyebrow ? 'mt-5' : ''}`} data-id="element-199" data-mp="1v3ou1mxe1u5">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed text-muted ${align === 'center' ? 'mx-auto max-w-prose' : 'max-w-prose'}`} data-id="element-200" data-mp="uj7tqkxoaavs">
          {lead}
        </p> : null}
    </div>;
}